import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatConversationListUtilityClass(slot) {
  return generateUtilityClass('MuiChatConversationList', slot);
}
export const chatConversationListClasses = generateUtilityClasses('MuiChatConversationList', ['root', 'scroller', 'item', 'itemAvatar', 'itemContent', 'itemTitle', 'itemPreview', 'itemTimestamp', 'itemUnreadBadge', 'itemActions', 'itemSelected', 'itemUnread', 'itemFocused', 'compact']);
const slots = {
  root: ['root'],
  scroller: ['scroller'],
  item: ['item'],
  itemAvatar: ['itemAvatar'],
  itemContent: ['itemContent'],
  itemTitle: ['itemTitle'],
  itemPreview: ['itemPreview'],
  itemTimestamp: ['itemTimestamp'],
  itemUnreadBadge: ['itemUnreadBadge'],
  itemActions: ['itemActions'],
  itemSelected: ['itemSelected'],
  itemUnread: ['itemUnread'],
  itemFocused: ['itemFocused'],
  compact: ['compact']
};
export const useChatConversationListUtilityClasses = classes => composeClasses(slots, getChatConversationListUtilityClass, classes);